import { render, staticRenderFns } from "./setting.vue?vue&type=template&id=89305410&scoped=true&"
import script from "./setting.vue?vue&type=script&lang=ts&"
export * from "./setting.vue?vue&type=script&lang=ts&"
import style0 from "./setting.vue?vue&type=style&index=0&id=89305410&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89305410",
  null
  
)

export default component.exports